import App from './informaSearchApp.js';
import CompaniesFactory from './factories/companiesFactory.js';
import SavedSearchFactory from './factories/savedSearchFactory.js';
import HeadlineToggleController from './controllers/headlineToggleController.js';
import FreeContentToggleController from './controllers/FreeContentToggleController.js';
import InformaFacetsController from './controllers/informaFacetsController.js';
import InformaFacetsDataController from './controllers/informaFacetsDataController.js';
import InformaDatesController from './controllers/informaDatesController.js';
import InformaResultsController from './controllers/informaResultsController.js';
import EmailRssController from './controllers/emailRssController.js';
import TypeaheadController from './controllers/TypeaheadController.js';
import HeadlineSearchController from './controllers/headlineSearchController.js';
import PageSizeController from './controllers/pageSizeController.js';
import SavedSearchController from './controllers/savedSearchController.js';
import SortByDateController from './controllers/sortByDateController.js';
import SortBySelectController from './controllers/sortBySelectController.js';

import AngularUIBootstrap from './ui-bootstrap-custom-tpls-1.2.4.min.js';
import AdvanceSearchController from './controllers/advanceSearchController.js';